function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#wifi_svg__clip0_1_114)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.44 13.736a3.145 3.145 0 00-4.48 0L11.2 16l2.24-2.264zm4.48-4.526a9.438 9.438 0 00-13.44 0l2.24 2.264a6.29 6.29 0 018.96 0l2.24-2.264zM0 4.684l2.24 2.264c4.95-5 12.97-5 17.92 0l2.24-2.264a15.735 15.735 0 00-22.4 0z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "wifi_svg__clip0_1_114"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23v16H0z"
})));

function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgWifi;